<template>
    <div style="height: 100%;width: 100%;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack" right-text="我的预约" @click-right="openMyOrder"/>
        <el-table height="calc(100% - 6rem)" :data="hairHeadStaffs" show-header style="width: 100%" class="mytable" ref="hairstaff" @row-click="openMemberInfo">
            <el-table-column prop="membername" align="center" label="姓名"  width="80px"></el-table-column>
            <el-table-column prop="targerday" align="center" label="到店" width="60px">
            </el-table-column>
            <el-table-column prop="saledate" align="center" label="最近到店" width="100px">
                <template slot-scope="scope">
                    {{$moment(scope.row.accoundate).format('MM-DD')}}({{scope.row.days}})
                </template>
            </el-table-column>
            <el-table-column prop="lable" align="center" label="预约/拍灯">
                <template slot-scope="scope">
                    <el-button type="primary" icon="el-icon-s-custom" size="mini" circle @click.stop="openHairLog(scope.row)"></el-button>
                    <el-button type="primary" icon="el-icon-date" size="mini" circle @click.stop="openYy(scope.row)" v-if="scope.row.hasorder==1"></el-button>
                    <el-button type="danger" icon="el-icon-date" size="mini" circle @click.stop="openYy(scope.row)" v-else></el-button>
                    <el-button type="success" icon="el-icon-s-opportunity" size="mini" v-if="scope.row.days<30" circle @click.stop="getBeautyddTargerById(scope)"></el-button>
                    <el-button type="warning" icon="el-icon-s-opportunity" size="mini" v-else-if="scope.row.days>=30 && scope.row.days<60" circle @click.stop="getBeautyddTargerById(scope)"></el-button>
                    <el-button type="danger" icon="el-icon-s-opportunity" size="mini"  v-else-if="scope.row.days>=60 && scope.row.days<180" circle @click.stop="getBeautyddTargerById(scope)"></el-button>
                    <el-button type="info" icon="el-icon-s-opportunity" size="mini" v-else circle @click.stop="getBeautyddTargerById(scope)"></el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                hairHeadStaffs:[],
                staffid:"",
                storeid:localStorage.getItem("storeid"),
                scrollTop:0
            }
        },
        activated() {
            //console.log(this.scrollTop);
            this.scrollTop=sessionStorage.getItem("hairScrollTop");
            
                setTimeout(() => {
                    this.$refs.hairstaff.bodyWrapper.scrollTop = this.scrollTop;
                }, 100);
            
        },
        created: function () {
            this.staffid=this.$route.query.staffid;
            if(!this.staffid){
                this.staffid=localStorage.getItem("querystaffid");
            }
            this.getHairHeadStaff();
        },
        beforeRouteEnter(to,from,next){
            sessionStorage.setItem("hairpath",from.path);
            /*if (from.path == "/hairmemberinfo" || from.path=="/hairlog" || from.path=="/myhairorder" || from.path=="/hairorder" || from.path=="/"){
                to.meta.keepAlive = true;
            }
            else{
                to.meta.keepAlive = false;
            }*/
            next();
        },
        methods: {
            calScroll(){
                this.scrollTop=sessionStorage.getItem("hairScrollTop");
            
                setTimeout(() => {
                    this.$refs.hairstaff.bodyWrapper.scrollTop = this.scrollTop;
                }, 100);
            },
            openHairLog(row){
                sessionStorage.setItem("hairScrollTop",this.$refs.hairstaff.bodyWrapper.scrollTop);
                //this.scrollTop=this.$refs.hairstaff.bodyWrapper.scrollTop;
                this.$router.push({path:"/hairlog",query:{
                    cardid:row.cardid,
                    memberid:row.memberid
                }});
            },
            openMyOrder(){
                sessionStorage.setItem("hairScrollTop",this.$refs.hairstaff.bodyWrapper.scrollTop);
                this.$router.push({path:"/myhairorder",query:{
                    staffid:this.staffid,
                }});
            },
            openYy(row){
                sessionStorage.setItem("hairScrollTop",this.$refs.hairstaff.bodyWrapper.scrollTop);
                this.$router.push({path:"/hairorder",query:{
                    cardid:row.cardid,
                }});
            },
            openMemberInfo(row){
                sessionStorage.setItem("hairScrollTop",this.$refs.hairstaff.bodyWrapper.scrollTop);
                this.$router.push({path:"/hairmemberinfo",query:{
                    cardid:row.cardid,
                    memberid:row.memberid
                }});
            },
            getHairHeadStaff(){
                this.$post("hairmanager/getHairHeadStaff",{storeid:this.storeid,staffid:this.staffid}).then(res=>{
                    if(res.sucess){
                        this.hairHeadStaffs=res.object;
                        let path=sessionStorage.getItem("hairpath");
                        if (path == "/hairmemberinfo" || path=="/hairlog" || path=="/myhairorder" || path=="/hairorder" || path=="/"){
                            this.calScroll();
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/manager/hairstaff.vue